import React, { ReactElement, useEffect, useState } from "react";
import { RiH4 } from "react-icons/ri";
import Help, { ARTICLES } from "../../../components/help/Help";
import SquareIcon from "../../../components/square-icon/SquareIcon";
import { StepProps } from "./base";

export default function OnboardingStep(props: StepProps): ReactElement {
    return (
        <div>
            <Help articleId={ARTICLES.ONBOARDING_DONE} />
            <h4 className="mb-3">
                Add Foqal to a Slack Channel.
            </h4>
            <div className="d-flex gap-4 align-items-start">
                <div className="col-6">

                    <img
                        src="https://static.foqal.io/agent/agent-invite-rebrand-closer.gif"
                        className="w-100 rounded shadow"
                        alt="How to invite agent"
                    />
                </div>
                <div className="col">
                    <div>

                        <div className="mt-2">
                            <SquareIcon className="me-2">1</SquareIcon>
                            {" "}
                            Go to your Slack workspace and find the channel in which you want to install Foqal Agent.
                            If this is the first time you are testing, you may want to
                            {" "}
                            <a
                                href="https://slack.com/help/articles/201402297-Create-a-channel"
                                target="_blank"
                                rel="noreferrer"
                                className="text-decoration-none"
                            >
                                create a new test channel
                            </a>
                            .
                        </div>
                        <div className="pt-3">
                            <SquareIcon className="me-2">2</SquareIcon>
                            {" "}
                            Type
                            {" "}
                            <code>/invite @Agent</code>
                            {" "}
                            in the channel and hit send.
                        </div>
                        <div className="pt-3">
                            <SquareIcon className="me-2">3</SquareIcon>
                            {" "}
                            Once you added Agent to a Slack channel, click Finish Setup.
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
}
